export const ROUTE_UPDATE = "route/update";

export function updateRoute({ location, prevLocation }) {
  return (dispatch) =>
    dispatch({
      type: ROUTE_UPDATE,
      payload: { location, prevLocation },
    });
}
